@if (logoTitle) {
    <button
        class="btn marketsubtype-logo-button"
        [placement]="tooltipPlacement"
        [floatUi]="popper.content"
        [applyClass]="'market-subtype-tooltip'"
        [appendTo]="tooltipAppendTo"
        [boundariesElement]="tooltipBoundaries"
        [hideOnScroll]="true"
        [hideOnClickOutside]="true"
        [arrowClass]="'popper-arrow'"
        [preventOverflow]="true"
        [class.marketsubtype-logo-clicked]="tooltip.showTooltip"
        [class.marketsubtype-logo-wrap-title]="wrapMarketLogoTitle"
        (click)="toggleTooltip($event)"
        (onHidden)="onCloseTooltip()"
        (onShown)="trackPopupShow()">
        {{ logoTitle }}
    </button>

    <vn-popper-content #popper [cssClass]="popperClass">
        <ng-container content>
            <div class="tooltip-header">
                <div class="title">{{ tooltip.title }}</div>
                <div class="close-button theme-ex" (click)="marketSubtypePopper.close()"></div>
            </div>
            <div class="message" [innerHTML]="tooltip.message"></div>
            <div class="message link-text" [innerHTML]="tooltip.linkText" (click)="onTooltipLinkClick()"></div>
        </ng-container>
    </vn-popper-content>
}
